import {
  //
  WORKFLOW_CONDITION_CONTAINS,
  WORKFLOW_CONDITION_EQUALS,
  WORKFLOW_CONDITION_NOT_EQUAL,
  //
  WORKFLOW_FIELD_TYPE_DATETIME,
  WORKFLOW_FIELD_TYPE_DD_MM,
  //
  WORKFLOW_FIELD_TYPE_DD_MM_YYYY,
  WORKFLOW_FIELD_TYPE_INTEGER,
  WORKFLOW_FIELD_TYPE_MM_DD,
  WORKFLOW_FIELD_TYPE_MM_DD_YYYY,
  WORKFLOW_FIELD_TYPE_MMDD,
  //
  WORKFLOW_FIELD_TYPE_TEXT,
  WORKFLOW_FIELD_TYPE_YYYY_MM_DD,
  WORKFLOW_FIELD_TYPE_YYYYMMDD
} from 'Constants/'
import { Flex, RadioButtonsGroup } from 'mailup-web-components'
import {
  fieldTypeExistingFilterState,
  step2State
} from 'Pages/Workflow/recoil/state/step2'

import { useIntl } from 'react-intl'

import { useRecoilState, useRecoilValue } from 'recoil'

import InputAction from './InputAction'
import InputFieldType from './InputFieldType'
import InputFieldValueNumeric from './InputFieldValueNumeric'
import InputFieldValueText from './InputFieldValueText'
import InputIdField from './InputIdField'

import InputIdFieldFilterDate from './InputIdFieldFilterDate'
import InputIdFieldFilterDatetime from './InputIdFieldFilterDatetime'
import InputIdFieldFilterNumeric from './InputIdFieldFilterNumeric'
import InputIdFieldFilterText from './InputIdFieldFilterText'
import InputIdFilter from './InputIdFilter'

const fieldValueTextConditions = [
  WORKFLOW_CONDITION_CONTAINS,
  WORKFLOW_CONDITION_EQUALS,
  WORKFLOW_CONDITION_NOT_EQUAL
]

const dateConditions = [
  WORKFLOW_FIELD_TYPE_DD_MM_YYYY,
  WORKFLOW_FIELD_TYPE_DD_MM,
  WORKFLOW_FIELD_TYPE_MM_DD_YYYY,
  WORKFLOW_FIELD_TYPE_MM_DD,
  WORKFLOW_FIELD_TYPE_YYYYMMDD,
  WORKFLOW_FIELD_TYPE_MMDD,
  WORKFLOW_FIELD_TYPE_YYYY_MM_DD
]

const StartTypeSubscriberField = () => {
  const intl = useIntl()

  const { FieldType, IdFieldFilter } = useRecoilValue(step2State)

  const [useExisting, setUseExisting] = useRecoilState(
    fieldTypeExistingFilterState
  )

  const handleUseExistingChange = (v) => {
    setUseExisting(v)
  }

  const useExistingOptions = [
    {
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.CreateFilterLabel'
      }),
      value: 'use-custom',
      'data-mu-test': 'new-custom'
    },
    {
      label: intl.formatMessage({
        id: 'Load.AutomationWorkflow.UseExistingFilterLabel'
      }),
      value: 'use-existing',
      'data-mu-test': 'use-existing'
    }
  ]

  return (
    <>
      <Flex width='100%' justifyContent='center' margin='0 0 24px 0'>
        <RadioButtonsGroup
          items={useExistingOptions}
          onChange={handleUseExistingChange}
          value={useExisting}
        />
      </Flex>

      {useExisting === 'use-custom' ? (
        <>
          <InputIdField />
          <InputFieldType />

          {FieldType === WORKFLOW_FIELD_TYPE_INTEGER && (
            <>
              <InputIdFieldFilterNumeric />
              <InputFieldValueNumeric />
            </>
          )}

          {FieldType === WORKFLOW_FIELD_TYPE_TEXT && (
            <>
              <InputIdFieldFilterText />

              {fieldValueTextConditions.includes(IdFieldFilter) && (
                <InputFieldValueText />
              )}
            </>
          )}

          {dateConditions.includes(FieldType) && <InputIdFieldFilterDate />}

          {FieldType === WORKFLOW_FIELD_TYPE_DATETIME && (
            <InputIdFieldFilterDatetime />
          )}
        </>
      ) : (
        <>
          <InputIdFilter />
          <InputAction />
        </>
      )}
    </>
  )
}

export default StartTypeSubscriberField
